export const GET_PORTAL_TEMPLATE_FILES_START = 'schoolRoom/GET_PORTAL_TEMPLATE_FILES_START';
export const GET_PORTAL_TEMPLATE_FILES_COMPLETED = 'schoolRoom/GET_PORTAL_TEMPLATE_FILES_COMPLETED';
export const GET_PORTAL_TEMPLATE_FILES_FAILED = 'schoolRoom/GET_PORTAL_TEMPLATE_FILES_FAILED';

export const UPDATE_PORTAL_TEMPLATE_FILE_START = 'schoolRoom/UPDATE_PORTAL_TEMPLATE_FILE_START';
export const UPDATE_PORTAL_TEMPLATE_FILE_FAILED = 'schoolRoom/UPDATE_PORTAL_TEMPLATE_FILE_FAILED';

export const UPDATE_PORTAL_CSS_VARIABLES_FILE_COMPLETED = 'schoolRoom/UPDATE_PORTAL_CSS_VARIABLES_FILE_COMPLETED';
export const CHANGE_PORTAL_THEMES_STATE = 'schoolRoom/CHANGE_PORTAL_THEMES_STATE';